var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationLastPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.08594 11.7109C0.648438 12.112 0.630208 12.513 1.03125 12.9141C1.46875 13.3151 1.88802 13.3151 2.28906 12.9141L7.97656 7.22656C8.15885 7.08073 8.25 6.88021 8.25 6.625C8.25 6.36979 8.15885 6.16927 7.97656 6.02344L2.28906 0.335938C1.88802 -0.0651042 1.46875 -0.0651042 1.03125 0.335938C0.630208 0.736979 0.648438 1.13802 1.08594 1.53906L6.11719 6.625L1.08594 11.7109Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationLastPage);
export default __webpack_public_path__ + "static/media/pagination-last-page.c6bdcfc0f207ea889fc30904bbf92af9.svg";
export { ForwardRef as ReactComponent };